/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Template_Category_LeadsInputs */

const cs_automation_template_category_leads = /** @type {(inputs: Automation_Template_Category_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leady`)
};

const en_automation_template_category_leads = /** @type {(inputs: Automation_Template_Category_LeadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leads`)
};

/**
* | output |
* | --- |
* | "Leads" |
*
* @param {Automation_Template_Category_LeadsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_template_category_leads = /** @type {((inputs?: Automation_Template_Category_LeadsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Template_Category_LeadsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_template_category_leads(inputs)
	return cs_automation_template_category_leads(inputs)
});